module.exports = __webpack_public_path__ + "static/media/nucleo-logo.92e7581a.svg";